// Central registry of all SVG/image paths used across the app.
// Organized by route name (matching routes.js) with shared keys for cross-cutting assets.

// --- Country Flags ---
import indonesia from "../assets/images/Indonesia.svg";
import vietnam from "../assets/images/vietnam.svg";
import thailand from "../assets/images/Thailand.svg";
import cambodia from "../assets/images/Cambodia.svg";
import laos from "../assets/images/Laos.svg";
import philippines from "../assets/images/Phillipines.svg";
import pakistan from "../assets/images/Pakistan.svg";
import bangladesh from "../assets/images/Bangladesh.svg";
import malaysia from "../assets/images/Malaysia.svg";

// --- Arrows ---
import backArrow from "../assets/images/backArrow.svg";
import backArrowWhite from "../assets/images/BackArrowWhite.svg";
import rightArrowBlue from "../assets/images/rightArrowBlue.svg";
import chevronRight from "../assets/images/chevron-right.svg";
import arrowBlue from "../assets/images/arrowBlue.svg";
import arrowRight from "../assets/images/arrow-left.svg";
import arrowLeft from "../assets/images/arrowLeft.svg";
import dropdownArrow from "../assets/images/Dropdown_Arrow.svg";

// --- Icons ---
import plusIcon from "../assets/images/plusIcon.svg";
import profileIcon from "../assets/images/profileIcon.svg";
import crossIcon from "../assets/images/crossIcon.svg";
import info from "../assets/images/info.svg";
import calendar from "../assets/images/calendar.svg";
import userIcon from "../assets/images/icon.png";
import cardIcon from "../assets/images/cardIcon.svg";
import tableListView from "../assets/images/tableListView.svg";
import tableCardView from "../assets/images/tableCardView.svg";
import downloadIcon from "../assets/images/download.svg";
import downloadFileIcon from "../assets/images/downloadfile_icon.png";
import showPasswordIcon from "../assets/images/showPasswordIcon.svg";
import hidePasswordIcon from "../assets/images/hidePasswordIcon.svg";
import { ReactComponent as storeIcon } from "../assets/images/store.svg";

// --- Logos ---
import unileverLogo from "../assets/images/unilever-logo.svg";
import ucubeAiFrame from "../assets/images/Frame.svg";
import ucubeTextLogo from "../assets/images/UCubeTextLogo.svg";
import ucubeIcon from "../assets/images/UCubeIcon.svg";

// --- Header (global) ---
import logout from "../assets/images/logout.svg";
import hamMenu from "../assets/images/hamMenu.svg";
import crossMenu from "../assets/images/crossMenu.svg";
import opDashboardBlue from "../assets/images/opDashboard_blue.svg";
import ucubeGraphBlue from "../assets/images/ucubeGraph_blue.svg";
import logoutBlue from "../assets/images/logout_blue.svg";
import userManageBlue from "../assets/images/userManage_blue.svg";
import dropupdownWhite from "../assets/images/dropupdown-white.svg";

// --- Landing Header / Hamburger ---
import closeIcon from "../assets/images/close.svg";
import locate from "../assets/images/locate.svg";
import fieldForce from "../assets/images/fieldForce.svg";
import home from "../assets/images/Home.svg";
import graphBar from "../assets/images/u_graph-bar.svg";
import gold from "../assets/images/gold.svg";
import adminConfig from "../assets/images/AdminConfig.svg";
import addSalesperson from "../assets/images/addSalesperson.svg";
import user from "../assets/images/user.svg";

// --- Page Background ---
import lilacAurora from "../assets/images/DM_Lilac Aurora.png";

// --- Landing Page ---
import dtFieldForceBackground from "../assets/images/DTFieldForceBackground.svg";
import ucubeLocateCardBackground from "../assets/images/UCubeLocateCardBackground.svg";
import ucubeFieldForce from "../assets/images/UCubeFieldForce.png";
import ucubeLocate from "../assets/images/UCubeLocate.png";
import ellipseSmleft from "../assets/images/EllipseSmleft.svg";
import ellipseSmright from "../assets/images/EllipseSmright.svg";
import autograph from "../assets/images/Autograph.svg";
import settingsAccountBox from "../assets/images/SettingsAccountBox.png";

// --- HomePage / UCubeFieldForce ---
import teamViewIcon from "../assets/images/u_users-alt.svg";
import distributorViewIcon from "../assets/images/u_truck-loading.svg";
import disciplinaryKpisIcon from "../assets/images/fi_map-pin.svg";
import ucubeFieldForceLogo from "../assets/images/UCubeFieldForce.png";

// --- HomePage / TabView ---
import barChartWhite from "../assets/images/fi_bar-chart_white.svg";
import barChartBlue from "../assets/images/fi_bar-chart_blue.svg";
import profileSmallBlue from "../assets/images/profileIcon_small_blue.svg";
import profileSmallWhite from "../assets/images/profileIcon_small_white.svg";
import kpiWhite from "../assets/images/kpiWhite.svg";
import kpiBlue from "../assets/images/kpiBlue.svg";
import closeModal from "../assets/images/closeModal.svg";
import uniCornRight from "../assets/images/uniconRight.svg";
import infoBlue from "../assets/images/info-circle-blue.svg";
import closeBlack from "../assets/images/close_black.svg";

// --- HomePage / KPI Views ---
import viewDetailsArrow from "../assets/images/viewDetailsArrow.svg";
import noDataFound from "../assets/images/nodatafound.png";
import mapPinAlt from "../assets/images/u_map-pin-alt.svg";
import locationPinAlt from "../assets/images/u_location-pin-alt.svg";
import fiClock from "../assets/images/fi_clock.svg";
import disc from "../assets/images/disc.svg";
import rightArrowBlack from "../assets/images/rightArrowBlack.svg";
import rightArrowLight from "../assets/images/RightArrowLight.svg";
import category from "../assets/images/Category.svg";

// --- HomePage / InformationModal ---
import popupClose from "../assets/images/popupclose.svg";
import infoCircle from "../assets/images/info-circle.svg";
import dragBar from "../assets/images/drag-bar.svg";
import alertCircle from "../assets/images/alert-circle.svg";

// --- HomePage / BrandingLoader ---
import loaderGif from "../assets/images/loader.gif";

// --- SmTracking ---
import salesTarget from "../assets/images/salesTarget.svg";
import productiveCall from "../assets/images/productiveCall.svg";
import notes from "../assets/images/notes.svg";
import refresh from "../assets/images/refresh.svg";
import outlet from "../assets/images/outlet.svg";
import packageIcon from "../assets/images/package.svg";
import searchIcon from "../assets/images/search-icon.svg";
import filterListIcon from "../assets/images/filter.svg";
import profileSm from "../assets/images/Profile.svg";
import greenUserIcon from "../assets/images/GreenUserIcon.svg";
import orangeUserIcon from "../assets/images/OrangeUserIcon.svg";
import filterCrossIcon from "../assets/images/FilterCrossIcon.svg";
import outletIcon1 from "../assets/images/OutletIcon1.svg";
import outletIcon2 from "../assets/images/OutletIcon2.svg";
import outletIcon3 from "../assets/images/OutletIcon3.svg";
import outletIcon4 from "../assets/images/OutletIcon4.svg";
import outletIcon5 from "../assets/images/OutletIcon5.svg";
import outletIcon6 from "../assets/images/OutletIcon6.svg";
import outletIcon7 from "../assets/images/OutletIcon7.svg";
import solidDownArrow from "../assets/images/SolidDownArrow.svg";
import solidUpArrow from "../assets/images/SolidUpArrow.svg";
import yellowWarning from "../assets/images/yellowWarning.svg";
import checkboxChecked from "../assets/images/checkbox_checked.svg";
import checkboxUnchecked from "../assets/images/checkbox_unchecked.svg";
import checkboxUncheckedNew from "../assets/images/checkbox_unchecked_new.svg";
import polygonArrow from "../assets/images/Polygon.svg";
import filterDropdownArrow from "../assets/images/filterDropdownArrow.svg";
import filterChipClose from "../assets/images/FilterChipClose.svg";
import closeFilter from "../assets/images/closefilter.svg";
import mapZoomIn from "../assets/images/MapZoomIn.svg";
import mapZoomOut from "../assets/images/MapZoomOut.svg";
import intradaySalesDollar from "../assets/images/IntradaySalesDollar.svg";
import lastOrderCalender from "../assets/images/LastOrderCalender.svg";
import smTaggedUser from "../assets/images/SmTaggedUser.svg";
import graphUp from "../assets/images/GraphUp.svg";
import redoIcon from "../assets/images/redo.svg";

const imagePaths = {
  common: {
    countryFlags: {
      indonesia,
      vietnam,
      thailand,
      cambodia,
      laos,
      philippines,
      pakistan,
      bangladesh,
      malaysia
    },
    arrows: {
      arrowRight,
      arrowLeft,
      backArrow,
      backArrowWhite,
      rightArrowBlue,
      chevronRight,
      arrowBlue,
      dropdownArrow,
      rightArrowLight,
    },
    icons: {
      plusIcon,
      profileIcon,
      crossIcon,
      info,
      calendar,
      ellipseSmright,
      closeIcon,
      profileSm,
      userIcon,
      cardIcon,
      tableListView,
      tableCardView,
      cardIcon,
      downloadIcon,
      downloadFileIcon,
      showIcon: showPasswordIcon,
      hideIcon: hidePasswordIcon,
      storeIcon,
      redoIcon,
    },
    logos: {
      unileverLogo,
      ucubeAiFrame,
      ucubeTextLogo,
      ucubeIcon,
    },
  },

  header: {
    logout,
    hamMenu,
    crossMenu,
    opDashboardBlue,
    ucubeGraphBlue,
    logoutBlue,
    userManageBlue,
    dropupdownWhite,
  },
  landingHeader: {
    hamMenu,
    closeIcon,
    locate,
    logout,
    userManageBlue,
    fieldForce,
    home,
    graphBar,
    gold,
    opDashboardBlue,
    adminConfig,
    addSalesperson,
    user,
  },

  pageBackground: {
    lilacAurora,
  },

  landingscreen: {
    dtFieldForceBackground,
    ucubeLocateCardBackground,
    ucubeFieldForce,
    ucubeLocate,
    ellipseSmleft,
    autograph,
    settingsAccountBox,
  },

  adminconfigurationpage: {
    arrowBlue,
  },

  homepage: {
    // UCubeFieldForce
    ucubeFieldForceLogo,
    teamViewIcon,
    distributorViewIcon,
    disciplinaryKpisIcon,
    alertCircle,
    // TabView
    barChartWhite,
    barChartBlue,
    profileSmallBlue,
    profileSmallWhite,
    kpiWhite,
    kpiBlue,
    closeModal,
    uniCornRight,
    // KPI Views
    viewDetailsArrow,
    noDataFound,
    mapPinAlt,
    locationPinAlt,
    fiClock,
    disc,
    rightArrowBlack,
    category,
    // InformationModal
    popupClose,
    infoCircle,
    dragBar,
    // BrandingLoader
    loaderGif,
    closeBlack,
    infoBlue
  },

  smTracking: {
    backArrow,
    salesTarget,
    productiveCall,
    category,
    notes,
    refresh,
    outlet,
    packageIcon,
    searchIcon,
    filterListIcon,
    profileSm,
    greenUserIcon,
    orangeUserIcon,
    overlayClose: closeFilter,
    filterCrossIcon,
    outletIcon1,
    outletIcon2,
    outletIcon3,
    outletIcon4,
    outletIcon5,
    outletIcon6,
    outletIcon7,
    solidDownArrow,
    solidUpArrow,
    yellowWarning,
    checkboxChecked,
    checkboxUnchecked: checkboxUncheckedNew,
    polygonArrow,
    filterDropdownArrow,
    filterChipClose,
    mapZoomIn,
    mapZoomOut,
    intradaySalesDollar,
    lastOrderCalender,
    smTaggedUser,
    graphUp,
  },
};

export default imagePaths;
